var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { styled } from 'goober';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import toast from 'react-hot-toast';
import { useLanguage } from '../../base/LanguageProvider';
import FSButton from '../../components/FSButton';
import FSToggle from '../../components/FSToggle';
import { withRoot } from '../../data/baobab/withRoot';
import { createEntryLinkPath, getExpirationData } from '../../data/entryLink/entryLink';
import { useDisableEntryLink, useEntryLinks, useExportEntryLinks, useRefreshEntryLinks, useRegenerateEntryLink, } from '../../data/entryLink/entryLinkActions';
import { useActiveVersions } from '../../data/hooks/versions';
import { SheetRowPath } from '../../data/sheetRow/sheetRow';
import { useSheetRowsById } from '../../data/sheetRow/sheetRowHooks';
import { useTagContext } from '../../data/tag/tagContext';
import { getFullName, getInitials } from '../../data/user/user';
import { useUsers } from '../../data/user/userActions';
import { useAuth } from '../../providers/AuthProvider';
import { ArrowDown, ChevronDown, Clock, Connection, Copy, Delete, Edit, Refresh } from '../../shared/icons/icons';
import { CheckBox, ThreeStateCheckBox } from '../../shared/input/CheckBox';
import Input from '../../shared/input/Input';
import Manager from '../../shared/modal/Manager';
import UserAvatar from '../../shared/userprofile/Avatar';
import { Loading } from '../../styled/Basic';
import { Page, PageTitle } from '../../styled/Page';
import { appColors } from '../../styled/useTheme';
import { downloadFile } from '../../util/helpers';
import { handleApiErrorMessage } from '../../util/message';
import { DeleteEntryLinkModal, EntryLinkModal, RegenerateLinksConfirmationModal } from './EntryLinkModal';
var MODAL_MENU_WIDTH = 212;
var Cell = styled('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n    text-align: left;\n    padding: 0px 4px;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n    text-align: left;\n    padding: 0px 4px;\n"])), function (_a) {
    var _b = _a.$evenly, $evenly = _b === void 0 ? false : _b;
    return ($evenly ? 'space-evenly' : 'center');
});
var Row = styled('li')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: grid;\n    align-items: center;\n    justify-content: center;\n    grid-template-columns: 0.5fr 1.25fr 5fr 1fr 0.7fr 1.05fr 0.5fr;\n    grid-gap: 8px;\n    height: 40px;\n    max-height: 40px;\n    min-height: 40px;\n    background-color: ", ";\n    border-bottom: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    display: grid;\n    align-items: center;\n    justify-content: center;\n    grid-template-columns: 0.5fr 1.25fr 5fr 1fr 0.7fr 1.05fr 0.5fr;\n    grid-gap: 8px;\n    height: 40px;\n    max-height: 40px;\n    min-height: 40px;\n    background-color: ", ";\n    border-bottom: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme, $selected = _a.$selected;
    return ($selected ? theme.colors.neutral.w100 : theme.colors.ui.white);
}, function (_a) {
    var theme = _a.theme, _b = _a.$header, $border = _b === void 0 ? false : _b;
    return $border ? '1px solid ' + theme.colors.neutral.w300 : 'none';
}, function (_a) {
    var theme = _a.theme, $selected = _a.$selected, $header = _a.$header;
    return $selected ? theme.colors.neutral.w100 : $header ? theme.colors.ui.white : theme.colors.neutral.w100;
});
var Items = styled('ul')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 0px;\n    flex-grow: 1;\n    list-style-type: none;\n    overflow-y: auto;\n    width: 100%;\n"], ["\n    padding: 0px;\n    flex-grow: 1;\n    list-style-type: none;\n    overflow-y: auto;\n    width: 100%;\n"])));
var ModalContainer = styled('div', forwardRef)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 8px;\n    background-color: ", ";\n    width: ", "px;\n    height: 265px;\n    border: 1px solid ", ";\n    box-shadow: ", ";\n    border-radius: 6px;\n    box-shadow: 0px 4px 16px rgba(107, 131, 160, 0.15);\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 8px;\n    background-color: ", ";\n    width: ", "px;\n    height: 265px;\n    border: 1px solid ", ";\n    box-shadow: ", ";\n    border-radius: 6px;\n    box-shadow: 0px 4px 16px rgba(107, 131, 160, 0.15);\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.ui.white;
}, MODAL_MENU_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.w200;
}, function (_a) {
    var theme = _a.theme;
    return theme.boxShadow;
});
function hasNecessaryDependencies(dependencies) {
    return !!dependencies.userMap && !!dependencies.sheetRowsMap && !!dependencies.tagMap;
}
function getSelectAllValue(selection, items) {
    return selection.size === 0 ? false : selection.size === (items === null || items === void 0 ? void 0 : items.length) ? true : null;
}
function getGeneratedSheetRowName(sheetRow) {
    return sheetRow.filterTag
        ? sheetRow.filterTag.description
            ? "".concat(sheetRow.filterTag.name, " ").concat(sheetRow.filterTag.description)
            : sheetRow.filterTag.name
        : sheetRow.name;
}
function useEntryLinksManager(dependencies) {
    var e_1, _a;
    var _b, _c, _d, _e, _f, _g, _h;
    var refreshEntryLinks = useRefreshEntryLinks();
    var disableEntryLinks = useDisableEntryLink();
    var regenerateEntryLinks = useRegenerateEntryLink();
    var exportEntryLinks = useExportEntryLinks();
    var entryLinksQuery = useEntryLinks({
        select: function (entryLinks) {
            var e_2, _a;
            if (!hasNecessaryDependencies(dependencies)) {
                return undefined;
            }
            var now = Date.now();
            var entryLinkItems = [];
            var uniqueClusterItemTitles = new Set();
            var sheetRowFilterItems = [];
            var allClusterFilterItems = [];
            var _loop_1 = function (el) {
                var e_3, _b, e_4, _c;
                var _d = getExpirationData(el, now), expiresIn = _d.expiresIn, hasExpired = _d.hasExpired;
                var user = dependencies.userMap[el.issuerId];
                var sheetRowPath = new SheetRowPath(el.path);
                var sheetRowsWithTags = [];
                try {
                    for (var _e = (e_3 = void 0, __values(sheetRowPath.segments)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var s = _f.value;
                        var row = dependencies.sheetRowsMap[s.sheetRowId];
                        if (row === undefined) {
                            continue;
                        }
                        if (row.tableTagId === null) {
                            sheetRowsWithTags.push(row);
                            continue;
                        }
                        if (!s.tagId) {
                            continue;
                        }
                        var tag = dependencies.tagMap[s.tagId];
                        sheetRowsWithTags.push(__assign(__assign({}, row), { filterTag: tag }));
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                var _loop_2 = function (sheetRow) {
                    if (sheetRow === null) {
                        return "continue";
                    }
                    var sheetRowItemTitle = getGeneratedSheetRowName(sheetRow);
                    var sheetRowItem = {
                        title: sheetRowItemTitle,
                        selected: dependencies.pathSelection.has(sheetRowItemTitle),
                        selectHandler: function () {
                            var newClusterSelection = new Set(dependencies.pathSelection);
                            if (!newClusterSelection.delete(sheetRowItemTitle)) {
                                newClusterSelection.add(sheetRowItemTitle);
                            }
                            dependencies.updateClusterSelectionHandler(newClusterSelection);
                        },
                    };
                    allClusterFilterItems.push(sheetRowItem);
                    if (!uniqueClusterItemTitles.has(sheetRowItemTitle) &&
                        sheetRowItemTitle.toLocaleLowerCase().includes(dependencies.pathSearch.toLocaleLowerCase())) {
                        uniqueClusterItemTitles.add(sheetRowItemTitle);
                        sheetRowFilterItems.push(sheetRowItem);
                    }
                };
                try {
                    for (var sheetRowsWithTags_1 = (e_4 = void 0, __values(sheetRowsWithTags)), sheetRowsWithTags_1_1 = sheetRowsWithTags_1.next(); !sheetRowsWithTags_1_1.done; sheetRowsWithTags_1_1 = sheetRowsWithTags_1.next()) {
                        var sheetRow = sheetRowsWithTags_1_1.value;
                        _loop_2(sheetRow);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (sheetRowsWithTags_1_1 && !sheetRowsWithTags_1_1.done && (_c = sheetRowsWithTags_1.return)) _c.call(sheetRowsWithTags_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                if (dependencies.pathSelection.size !== 0 &&
                    !sheetRowsWithTags.some(function (ct) { return ct && dependencies.pathSelection.has(getGeneratedSheetRowName(ct)); })) {
                    return "continue";
                }
                var versionsNames = el.versionIds
                    .map(function (id) { var _a; return (_a = dependencies.versionMap[id]) === null || _a === void 0 ? void 0 : _a.name; })
                    .filter(function (v) { return v !== undefined; });
                var lastSheetRow = sheetRowsWithTags.pop();
                var lineage = sheetRowsWithTags
                    .map(function (c) { return (c === null ? 'Root' : getGeneratedSheetRowName(c)); })
                    .join('/');
                entryLinkItems.push({
                    item: el,
                    expiresIn: expiresIn,
                    hasExpired: hasExpired,
                    interval: "".concat(el.intervalStart.getFullYear(), " - ").concat(el.intervalEnd.getFullYear()),
                    selected: dependencies.selection.has(el.id),
                    versions: versionsNames.join(', '),
                    createdBy: { initials: getInitials(user), fullName: getFullName(user) },
                    sheetRowPath: {
                        lineage: lineage,
                        sheetRowTitle: lastSheetRow ? getGeneratedSheetRowName(lastSheetRow) : '',
                    },
                    selectHandler: function () {
                        var _a;
                        var newSelection = new Map(dependencies.selection);
                        var entryLink = (_a = entryLinksQuery.data) === null || _a === void 0 ? void 0 : _a.entryLinkItems.find(function (l) { return l.item.id === el.id; });
                        if (!newSelection.delete(el.id) && entryLink !== undefined) {
                            newSelection.set(el.id, entryLink);
                        }
                        dependencies.updateSelectionHandler(newSelection);
                    },
                });
            };
            try {
                for (var entryLinks_1 = __values(entryLinks), entryLinks_1_1 = entryLinks_1.next(); !entryLinks_1_1.done; entryLinks_1_1 = entryLinks_1.next()) {
                    var el = entryLinks_1_1.value;
                    _loop_1(el);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (entryLinks_1_1 && !entryLinks_1_1.done && (_a = entryLinks_1.return)) _a.call(entryLinks_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return {
                entryLinkItems: entryLinkItems,
                sheetRowFilterItems: sheetRowFilterItems.sort(function (a, b) { return a.title.localeCompare(b.title); }),
                allClusterFilterItems: allClusterFilterItems,
            };
        },
        notifyOnChangeProps: ['data', 'error', 'isLoading', 'isError'],
        enabled: hasNecessaryDependencies(dependencies),
        onError: function (error) {
            handleApiErrorMessage(error);
        },
    });
    var filteredSelection = new Map(dependencies.selection);
    if (((_b = entryLinksQuery.data) === null || _b === void 0 ? void 0 : _b.entryLinkItems.length) &&
        filteredSelection.size > ((_c = entryLinksQuery.data) === null || _c === void 0 ? void 0 : _c.entryLinkItems.length)) {
        var updatedSelection = new Map();
        try {
            for (var _j = __values(entryLinksQuery.data.entryLinkItems), _k = _j.next(); !_k.done; _k = _j.next()) {
                var el = _k.value;
                if (dependencies.selection.has(el.item.id)) {
                    updatedSelection.set(el.item.id, el);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_a = _j.return)) _a.call(_j);
            }
            finally { if (e_1) throw e_1.error; }
        }
        filteredSelection = updatedSelection;
    }
    var selectAll = getSelectAllValue(dependencies.selection, (_d = entryLinksQuery.data) === null || _d === void 0 ? void 0 : _d.entryLinkItems);
    var sheetRowSelectAll = getSelectAllValue(dependencies.pathSelection, (_e = entryLinksQuery.data) === null || _e === void 0 ? void 0 : _e.sheetRowFilterItems);
    return {
        data: {
            entryLinkItems: (_f = entryLinksQuery.data) === null || _f === void 0 ? void 0 : _f.entryLinkItems,
            sheetRowFilterItems: (_g = entryLinksQuery.data) === null || _g === void 0 ? void 0 : _g.sheetRowFilterItems,
            allClusterFilterItems: (_h = entryLinksQuery.data) === null || _h === void 0 ? void 0 : _h.allClusterFilterItems,
            selectAll: selectAll,
            sheetRowSelectAll: sheetRowSelectAll,
            filteredSelection: filteredSelection,
        },
        isLoading: entryLinksQuery.isLoading,
        isExporting: exportEntryLinks.isLoading,
        isRefreshing: refreshEntryLinks.isLoading,
        isExpiring: disableEntryLinks.isLoading,
        isRegenerating: regenerateEntryLinks.isLoading,
        hasSelection: dependencies.selection.size > 0,
        isError: entryLinksQuery.isError,
        selectAllChangeHandler: function () {
            var _a, _b;
            var newSelection = selectAll
                ? new Map()
                : new Map((_b = (_a = entryLinksQuery.data) === null || _a === void 0 ? void 0 : _a.entryLinkItems.map(function (e) { return [e.item.id, e]; })) !== null && _b !== void 0 ? _b : dependencies.selection);
            dependencies.updateSelectionHandler(newSelection);
        },
        sheetRowSelectAllHandler: function () {
            var _a, _b;
            var newSelection = sheetRowSelectAll
                ? new Set()
                : new Set((_b = (_a = entryLinksQuery.data) === null || _a === void 0 ? void 0 : _a.sheetRowFilterItems.map(function (i) { return i.title; })) !== null && _b !== void 0 ? _b : dependencies.pathSelection);
            dependencies.updateClusterSelectionHandler(newSelection);
        },
        exportEntryLinksHandler: function () {
            return __awaiter(this, void 0, void 0, function () {
                var ids;
                return __generator(this, function (_a) {
                    ids = Array.from(filteredSelection.keys());
                    exportEntryLinks.mutate(ids, {
                        onSuccess: function (data) {
                            downloadFile(data, 'Entry Links.xlsx');
                            toast.success('File exported!');
                        },
                        onError: function (error) {
                            handleApiErrorMessage(error);
                        },
                    });
                    return [2 /*return*/];
                });
            });
        },
        refreshEntryLinksHandler: function () {
            var ids = Array.from(filteredSelection.keys());
            refreshEntryLinks.mutate(ids, {
                onSuccess: function () {
                    toast.success('Entry links refreshed!');
                },
                onError: function (error) {
                    handleApiErrorMessage(error);
                },
            });
        },
        expireEntryLinksHandler: function () {
            var ids = Array.from(filteredSelection.keys());
            disableEntryLinks.mutate(ids, {
                onSuccess: function () {
                    toast.success('Entry links expired!');
                },
                onError: function (error) {
                    handleApiErrorMessage(error);
                },
            });
        },
        regenerateEntryLinksHandler: function () {
            var ids = Array.from(filteredSelection.keys());
            regenerateEntryLinks.mutate(ids, {
                onSuccess: function () {
                    toast.success('Entry links regenerated!');
                },
                onError: function (error) {
                    handleApiErrorMessage(error);
                },
            });
        },
    };
}
export function EntryLinksManager() {
    var e_5, _a;
    var tagData = useTagContext().tagData;
    var sheetRowsById = useSheetRowsById();
    var activeVersions = useActiveVersions();
    var user = useAuth().user;
    var usersMap = useUsers({
        notifyOnChangeProps: ['data'],
        select: function (data) {
            return data.reduce(function (map, user) {
                map[user.id] = user;
                return map;
            }, {});
        },
    });
    var versionMapById = {};
    try {
        for (var activeVersions_1 = __values(activeVersions), activeVersions_1_1 = activeVersions_1.next(); !activeVersions_1_1.done; activeVersions_1_1 = activeVersions_1.next()) {
            var version = activeVersions_1_1.value;
            versionMapById[version.id] = version;
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (activeVersions_1_1 && !activeVersions_1_1.done && (_a = activeVersions_1.return)) _a.call(activeVersions_1);
        }
        finally { if (e_5) throw e_5.error; }
    }
    var _b = __read(useState(''), 2), pathSearch = _b[0], setPathSearch = _b[1];
    var _c = __read(useState(new Map()), 2), selection = _c[0], setSelection = _c[1];
    var _d = __read(useState(), 2), pathSelection = _d[0], setPathSelection = _d[1];
    var dependencies = {
        selection: selection,
        pathSearch: pathSearch,
        pathSelection: pathSelection !== null && pathSelection !== void 0 ? pathSelection : new Set(),
        sheetRowsMap: sheetRowsById,
        tagMap: tagData.tagById,
        userMap: usersMap.data,
        versionMap: versionMapById,
        updateSelectionHandler: function (selection) {
            setSelection(selection);
        },
        updateClusterSelectionHandler: function (update) {
            setPathSelection(update);
        },
    };
    var _e = useEntryLinksManager(dependencies), data = _e.data, isError = _e.isError, isLoading = _e.isLoading, isRefreshing = _e.isRefreshing, isExpiring = _e.isExpiring, isRegenerating = _e.isRegenerating, isExporting = _e.isExporting, hasSelection = _e.hasSelection, selectAllChangeHandler = _e.selectAllChangeHandler, sheetRowSelectAllHandler = _e.sheetRowSelectAllHandler, exportEntryLinksHandler = _e.exportEntryLinksHandler, expireEntryLinksHandler = _e.expireEntryLinksHandler, refreshEntryLinksHandler = _e.refreshEntryLinksHandler, regenerateEntryLinks = _e.regenerateEntryLinksHandler;
    useEffect(function () {
        setPathSelection(function (current) {
            var e_6, _a;
            if (current && data.sheetRowFilterItems && current.size > data.sheetRowFilterItems.length) {
                var updatedSelection = new Set();
                try {
                    for (var _b = __values(data.sheetRowFilterItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var c = _c.value;
                        if (c.selected) {
                            updatedSelection.add(c.title);
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
                return updatedSelection;
            }
            if (current || data.sheetRowFilterItems === undefined) {
                return current;
            }
            return new Set(data.sheetRowFilterItems.map(function (i) { return i.title; }));
        });
    }, [data.sheetRowFilterItems]);
    function sheetRowSearchChangeHandler(search) {
        var e_7, _a;
        var _b;
        setPathSearch(search);
        var updatedSelection = new Set();
        try {
            for (var _c = __values((_b = data.allClusterFilterItems) !== null && _b !== void 0 ? _b : []), _d = _c.next(); !_d.done; _d = _c.next()) {
                var c = _d.value;
                if (c.title.toLocaleLowerCase().includes(search.toLocaleLowerCase())) {
                    updatedSelection.add(c.title);
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_7) throw e_7.error; }
        }
        setPathSelection(updatedSelection);
    }
    // function createEntryLinkHandler() {
    //     const Modal = withRoot(EntryLinkModal);
    //     Manager.renderModal(<Modal />);
    // }
    function deleteEntryLinkHandler() {
        var ids = Array.from(data.filteredSelection.keys());
        var Modal = withRoot(DeleteEntryLinkModal);
        var onSuccess = function () {
            setSelection(new Map());
        };
        if (ids.length === 1) {
            Manager.renderModal(React.createElement(Modal, { entryLinkId: ids[0], onSuccess: onSuccess }));
            return;
        }
        Manager.renderModal(React.createElement(Modal, { entryLinkIds: ids, onSuccess: onSuccess }));
    }
    function editEntyLinkHandler() {
        var ids = Array.from(data.filteredSelection.keys());
        var Modal = withRoot(EntryLinkModal);
        if (ids.length === 1) {
            Manager.renderModal(React.createElement(Modal, { entryLinkId: ids[0] }));
            return;
        }
        Manager.renderModal(React.createElement(Modal, { entryLinkIds: ids }));
    }
    function regenerateEntryLinksHandler() {
        Manager.renderModal(React.createElement(RegenerateLinksConfirmationModal, { onConfirm: regenerateEntryLinks }));
    }
    return (React.createElement(EntryLinksManagerView, { data: __assign(__assign({}, data), { sheetRowSearch: pathSearch }), isError: isError, isLoading: isLoading, isExporting: isExporting, isRefreshing: isRefreshing, isExpiring: isExpiring, isRegenerating: isRegenerating, isEditDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.dataEntryLinkActions.canUpdate), 
        // isCreateDisabled={!user?.classActions.dataEntryLinkActions.canCreate}
        isDeleteDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.dataEntryLinkActions.canDelete), hasSelection: hasSelection, onClusterSearchChange: sheetRowSearchChangeHandler, 
        // onCreate={createEntryLinkHandler}
        onEdit: editEntyLinkHandler, onDelete: deleteEntryLinkHandler, onExport: exportEntryLinksHandler, onExpire: expireEntryLinksHandler, onRefresh: refreshEntryLinksHandler, onRegenerate: regenerateEntryLinksHandler, onSelectAll: selectAllChangeHandler, onClusterSelectAll: sheetRowSelectAllHandler }));
}
function EntryLinkItem(props) {
    var _a, _b;
    var entryLink = props.entryLink, onSelect = props.onSelect;
    var L = useLanguage().L;
    var entryLinkPath = createEntryLinkPath(entryLink.item.key);
    return (React.createElement(Row, { "$selected": entryLink.selected },
        React.createElement(Cell, null,
            React.createElement(CheckBox, { checked: entryLink.selected, action: onSelect })),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } },
            React.createElement(UserAvatar, { containerStyle: { marginRight: 15 }, initials: entryLink.createdBy.initials }),
            entryLink.createdBy.fullName),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } },
            React.createElement("span", { style: { width: '100%', height: '100%' } },
                entryLink.sheetRowPath.lineage,
                React.createElement("strong", null, "/".concat((_b = (_a = entryLink.sheetRowPath.filterTagName) !== null && _a !== void 0 ? _a : entryLink.sheetRowPath.sheetRowTitle) !== null && _b !== void 0 ? _b : 'Deleted Cluster')))),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } }, entryLink.versions),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } }, entryLink.interval),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } }, entryLink.expiresIn),
        React.createElement(Cell, { "$evenly": true },
            React.createElement(FSButton, { icon: Copy, "$type": "tertiary", "$color": "neutral", onClick: function () {
                    window.navigator.clipboard.writeText(entryLinkPath);
                    toast.success(L('Entry link copied to clipboard'));
                } }))));
}
function Header(props) {
    var L = useLanguage().L;
    var selectAll = props.selectAll, sheetRowSearch = props.sheetRowSearch, _a = props.sheetRowItems, sheetRowItems = _a === void 0 ? [] : _a, sheetRowsSelectAll = props.sheetRowsSelectAll, onSelectAll = props.onSelectAll, onClusterSelectAll = props.onClusterSelectAll, onClusterSearchChange = props.onClusterSearchChange;
    return (React.createElement(Row, { "$header": true, style: { marginBottom: 16 } },
        React.createElement(Cell, null,
            React.createElement(ThreeStateCheckBox, { value: selectAll, action: onSelectAll })),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } }, L('Created by')),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } },
            React.createElement("span", { style: { marginRight: 8 } }, L('Path')),
            React.createElement(ColumnFilterMenu, { items: sheetRowItems, search: sheetRowSearch, selectAll: sheetRowsSelectAll, onSelectAll: onClusterSelectAll, onSearchChange: onClusterSearchChange })),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } }, L('Versions')),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } }, L('Interval')),
        React.createElement(Cell, { style: { justifyContent: 'flex-start' } }, L('Expires in')),
        React.createElement(Cell, null,
            React.createElement("strong", { style: { color: 'transparent' } }, L('Copy')))));
}
function ColumnFilterMenu(props) {
    var items = props.items, search = props.search, selectAll = props.selectAll, onSelectAll = props.onSelectAll, onSearchChange = props.onSearchChange;
    var _a = __read(useState(), 2), triggerPosition = _a[0], setPosition = _a[1];
    var toggleRef = useRef(null);
    useEffect(function () {
        var mainContent = document.getElementById('content');
        var close = function () {
            setPosition(undefined);
        };
        var onMainContentClick = function (e) {
            var _a, _b, _c, _d;
            var targetElement = e.target;
            if (!(((_b = (_a = toggleRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.isSameNode(targetElement)) ||
                ((_d = (_c = toggleRef.current) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.contains(targetElement))) &&
                triggerPosition) {
                close();
            }
        };
        var onEscapePress = function (e) {
            if (e.key === 'Escape' && triggerPosition) {
                close();
            }
        };
        mainContent === null || mainContent === void 0 ? void 0 : mainContent.addEventListener('click', onMainContentClick, true);
        mainContent === null || mainContent === void 0 ? void 0 : mainContent.addEventListener('keydown', onEscapePress, true);
        return function () {
            mainContent === null || mainContent === void 0 ? void 0 : mainContent.removeEventListener('click', onMainContentClick, true);
            mainContent === null || mainContent === void 0 ? void 0 : mainContent.removeEventListener('keydown', onEscapePress, true);
        };
    }, [triggerPosition]);
    var content = items.map(function (i) { return (React.createElement("div", { key: i.title, style: { display: 'flex', alignItems: 'center', paddingLeft: 10 } },
        React.createElement(CheckBox, { checked: i.selected, action: i.selectHandler, label: i.title }))); });
    var modal = triggerPosition ? (React.createElement(ModalContainer, { style: {
            position: 'absolute',
            zIndex: 1,
            top: triggerPosition.top + triggerPosition.height + 8,
            left: triggerPosition.left - MODAL_MENU_WIDTH / 2 + triggerPosition.width / 2,
        } },
        React.createElement(Input, { autoFocus: true, value: search, onChange: function (e) { return onSearchChange(e.target.value); }, placeholder: "Search" }),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', marginTop: 8, paddingLeft: 10 } },
            React.createElement(ThreeStateCheckBox, { action: onSelectAll, value: selectAll, label: 'Select all' })),
        React.createElement("hr", { style: {
                border: "1px solid ".concat(appColors.neutral.w100),
                width: '100%',
                marginBottom: 8,
                marginTop: 8,
                opacity: 1,
            } }),
        React.createElement("div", { style: { overflowY: 'auto', flexGrow: 1 } }, content))) : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(FSToggle, { "$size": "small", "$color": "neutral", ref: toggleRef, checked: !!triggerPosition, icon: ChevronDown, onChange: function (e) {
                if (!e.target.checked) {
                    setPosition(undefined);
                    return;
                }
                var rect = e.target.getBoundingClientRect();
                setPosition(rect);
            } }),
        createPortal(modal, document.getElementById('portal'))));
}
export function EntryLinksManagerView(props) {
    var _a, _b;
    var L = useLanguage().L;
    var data = props.data, error = props.isError, isLoading = props.isLoading, 
    // onCreate,
    onEdit = props.onEdit, onDelete = props.onDelete, onExpire = props.onExpire, onRefresh = props.onRefresh, onRegenerate = props.onRegenerate, onSelectAll = props.onSelectAll, onClusterSelectAll = props.onClusterSelectAll, onExport = props.onExport, onClusterSearchChange = props.onClusterSearchChange, hasSelection = props.hasSelection, isExporting = props.isExporting, isRefreshing = props.isRefreshing, isExpiring = props.isExpiring, isRegenerating = props.isRegenerating, isEditDisabled = props.isEditDisabled, isDeleteDisabled = props.isDeleteDisabled;
    var content = error ? (React.createElement("div", { style: { display: 'grid', flexGrow: 1, placeItems: 'center' } },
        React.createElement("h3", null, L('An error occured')))) : ((_a = data.entryLinkItems) === null || _a === void 0 ? void 0 : _a.length) ? (React.createElement(Items, null, (_b = data.entryLinkItems) === null || _b === void 0 ? void 0 : _b.map(function (i) { return (React.createElement(EntryLinkItem, { key: i.item.id, entryLink: i, onSelect: i.selectHandler })); }))) : (React.createElement("div", { style: { display: 'grid', flexGrow: 1, placeItems: 'center' } }, isLoading ? React.createElement(Loading, null) : React.createElement("h3", null,
        " ",
        L('No entry links found'))));
    return (React.createElement(Page, null,
        React.createElement(PageTitle, null,
            React.createElement("h2", null, L('Entry Link Manager')),
            React.createElement(FSButton, { disabled: !hasSelection || isEditDisabled, "$type": "tertiary", icon: Edit, title: L('Edit'), style: { marginRight: '0.8em' }, onClick: onEdit }),
            React.createElement(FSButton, { disabled: !hasSelection || isEditDisabled, loading: isRegenerating, "$type": "tertiary", icon: Connection, title: L('Regenerate'), style: { marginRight: '0.8em' }, onClick: onRegenerate }),
            React.createElement(FSButton, { disabled: !hasSelection, loading: isExporting, "$type": "tertiary", icon: ArrowDown, title: L('Export'), style: { marginRight: '0.8em' }, onClick: onExport }),
            React.createElement(FSButton, { disabled: !hasSelection || isEditDisabled, loading: isRefreshing, "$type": "tertiary", icon: Refresh, title: L('Refresh'), style: { marginRight: '2em' }, onClick: onRefresh }),
            React.createElement(FSButton, { disabled: !hasSelection || isEditDisabled, loading: isExpiring, "$color": "error", "$type": "tertiary", icon: Clock, title: L('Expire'), style: { marginRight: '0.8em' }, onClick: onExpire }),
            React.createElement(FSButton, { disabled: !hasSelection || isDeleteDisabled, "$color": "error", "$type": "tertiary", icon: Delete, title: L('Delete'), style: { marginRight: '0.8em' }, onClick: onDelete })),
        React.createElement(Header, { onSelectAll: onSelectAll, selectAll: data.selectAll, sheetRowSearch: data.sheetRowSearch, sheetRowItems: data.sheetRowFilterItems, onClusterSelectAll: onClusterSelectAll, sheetRowsSelectAll: data.sheetRowSelectAll, onClusterSearchChange: onClusterSearchChange }),
        content));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
